import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CallProvider } from './contexts/CallContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './pages/Navbar';
import Footer from './components/Footer';
import CallOverlay from './components/CallOverlay';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Insights from './pages/Insights';
import Login from './pages/Login';
import Dashboard from './pages/employee/Dashboard';
import Timesheet from './pages/employee/Timesheet';
import Chat from './pages/employee/Chat';
import AdminPositions from './pages/admin/Positions';
import TimesheetReview from './pages/admin/TimesheetReview';
import AdminEmployees from './pages/admin/Employees';
import AdminProjects from './pages/admin/Projects';
import AdminHolidays from './pages/admin/Holidays';
import AdminLeaveRequests from './pages/admin/LeaveRequests';
import AdminReports from './pages/admin/Reports';
import AdminSettings from './pages/admin/Settings';
import AdminClients from './pages/admin/Clients';
import AdminConsultantRates from './pages/admin/ConsultantRates';
import AdminInvoices from './pages/admin/Invoices';
import AdminRoles from './pages/admin/Roles';
import ResumeBooster from './pages/admin/ResumeBooster';
import ChatPermissions from './pages/admin/ChatPermissions';
import Passkeys from './pages/admin/Passkeys';
import LeaveRequest from './pages/employee/LeaveRequest';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

export default function App() {
  return (
    <AuthProvider>
      <CallProvider>
        <BrowserRouter>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                {/* Legacy redirect */}
                <Route path="/learnmore" element={<Navigate to="/about" replace />} />
                {/* Protected employee routes */}
                <Route path="/employee" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/employee/timesheet" element={<ProtectedRoute><Timesheet /></ProtectedRoute>} />
                <Route path="/admin/positions" element={<ProtectedRoute adminOnly><AdminPositions /></ProtectedRoute>} />
                <Route path="/admin/timesheets" element={<ProtectedRoute adminOnly><TimesheetReview /></ProtectedRoute>} />
                <Route path="/admin/employees" element={<ProtectedRoute adminOnly><AdminEmployees /></ProtectedRoute>} />
                <Route path="/admin/projects" element={<ProtectedRoute adminOnly><AdminProjects /></ProtectedRoute>} />
                <Route path="/admin/holidays" element={<ProtectedRoute adminOnly><AdminHolidays /></ProtectedRoute>} />
                <Route path="/admin/leaves" element={<ProtectedRoute adminOnly><AdminLeaveRequests /></ProtectedRoute>} />
                <Route path="/admin/reports" element={<ProtectedRoute adminOnly><AdminReports /></ProtectedRoute>} />
                <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
                <Route path="/admin/clients" element={<ProtectedRoute adminOnly><AdminClients /></ProtectedRoute>} />
                <Route path="/admin/consultant-rates" element={<ProtectedRoute adminOnly><AdminConsultantRates /></ProtectedRoute>} />
                <Route path="/admin/invoices" element={<ProtectedRoute adminOnly><AdminInvoices /></ProtectedRoute>} />
                <Route path="/admin/roles" element={<ProtectedRoute adminOnly><AdminRoles /></ProtectedRoute>} />
                <Route path="/admin/resume-booster" element={<ProtectedRoute adminOnly><ResumeBooster /></ProtectedRoute>} />
                <Route path="/admin/chat-permissions" element={<ProtectedRoute adminOnly><ChatPermissions /></ProtectedRoute>} />
                <Route path="/admin/passkeys" element={<ProtectedRoute adminOnly><Passkeys /></ProtectedRoute>} />
                <Route path="/employee/leaves" element={<ProtectedRoute><LeaveRequest /></ProtectedRoute>} />
                <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
                {/* Catch-all */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <CallOverlay />
        </BrowserRouter>
      </CallProvider>
    </AuthProvider>
  );
}
